module.exports = __webpack_public_path__ + "img/team1.339b3ea1.png";